var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-grid tw-h-7 tw-w-7 tw-shrink-0 tw-place-content-center tw-rounded-full tw-bg-dark-green tw-text-sm tw-font-medium tw-text-white"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }